const constants = {
  title: 'Free up cash each month with Freedom Debt Relief',
  caption: 'Ozzy S., Freedom client²',
  image: '/next-assets/ozzy_customer_concept.webp',
  infoText: 'Individual results are not typical and will vary.',
  imageClassName: 'scale-[1.4] origin-top-right',
  quote:
    '“Right away, I had more money each month because of program costs so much less than what I was paying on my minimums.”',
  clientStories: [
    {
      title: 'Total Debt Resolved',
      value: '$22,738🎉',
    },
    {
      title: 'Monthly Payment',
      value: '$398',
    },
    {
      title: 'Debts Resolved',
      value: '8',
    },
  ],
  leadCTA: {
    button: 'Get a free evaluation',
    phone: '800-910-0065',
  },
  patti: {
    caption: 'Patti B., actual client',
    image: '/next-assets/image.png',
    infoText: '',
    imageClassName: 'scale-[1]',
    quote:
      '“Within a year, my first card was paid off. Then the second, then the third... After only a few years, all my debts were paid off.”',
    clientStories: [
      {
        title: 'Total Debt Resolved',
        value: '$17,183 🎉',
      },
      {
        title: 'Monthly Payment',
        value: '$362',
      },
      {
        title: 'Debts Resolved',
        value: '4',
      },
    ],
  },
  molly: {
    caption: 'Molly B., actual client',
    image: '/next-assets/client-stories/molly-cta.png',
    imageClassName: 'scale-[1]',
    infoText: '',
    quote:
      '“I feel so good, so relieved, and so happy to be moving forward with my life without debt"',
    clientStories: [
      {
        title: 'Total Debt Resolved',
        value: '$29,987 🎉',
      },
      {
        title: 'Monthly Payment',
        value: '$562',
      },
      {
        title: 'Debts Resolved',
        value: '6',
      },
    ],
  },
}

export default constants
